// extracted by mini-css-extract-plugin
export default {"iconNoColor":"IconNoColor_iconNoColor__0qiiK"};